const IS_INSTALL_PROMPT_SUPPORTED = 'onbeforeinstallprompt' in globalThis;
export default IS_INSTALL_PROMPT_SUPPORTED;
